// 会員登録
$(document).ready(function () {
    const targetNode = document.body; // 全体を監視
    const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            if (mutation.type === "childList") {
                $(".cf-app__field").each(function () {
                    const input = $(this).children("input");
                    const label = $(this).children("label");

                    if (input.length && label.length && input.index() < label.index()) {
                        label.insertBefore(input);
                    }
                });
            }
        });
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true, // 子孫要素も監視
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const prefecturesMap = {
        Hokkaidō: "北海道",
        Aomori: "青森県",
        Iwate: "岩手県",
        Miyagi: "宮城県",
        Akita: "秋田県",
        Yamagata: "山形県",
        Fukushima: "福島県",
        Ibaraki: "茨城県",
        Tochigi: "栃木県",
        Gunma: "群馬県",
        Saitama: "埼玉県",
        Chiba: "千葉県",
        Tōkyō: "東京都",
        Kanagawa: "神奈川県",
        Niigata: "新潟県",
        Toyama: "富山県",
        Ishikawa: "石川県",
        Fukui: "福井県",
        Yamanashi: "山梨県",
        Nagano: "長野県",
        Gifu: "岐阜県",
        Shizuoka: "静岡県",
        Aichi: "愛知県",
        Mie: "三重県",
        Shiga: "滋賀県",
        Kyōto: "京都府",
        Ōsaka: "大阪府",
        Hyōgo: "兵庫県",
        Nara: "奈良県",
        Wakayama: "和歌山県",
        Tottori: "鳥取県",
        Shimane: "島根県",
        Okayama: "岡山県",
        Hiroshima: "広島県",
        Yamaguchi: "山口県",
        Tokushima: "徳島県",
        Kagawa: "香川県",
        Ehime: "愛媛県",
        Kōchi: "高知県",
        Fukuoka: "福岡県",
        Saga: "佐賀県",
        Nagasaki: "長崎県",
        Kumamoto: "熊本県",
        Ōita: "大分県",
        Miyazaki: "宮崎県",
        Kagoshima: "鹿児島県",
        Okinawa: "沖縄県",
    };

    function convertSelectOptionsToJapanese(selectElement) {
        Array.from(selectElement.options).forEach((option) => {
            const romaji = option.value;
            if (prefecturesMap[romaji]) {
                option.textContent = prefecturesMap[romaji]; // 表示を漢字に変更
            }
        });
    }

    const observer = new MutationObserver(() => {
        const selectElement = document.getElementById("customer-address-province");

        if (selectElement) {
            //console.log('セレクトボックスが生成されました:', selectElement);
            convertSelectOptionsToJapanese(selectElement); // 変換処理を実行
            observer.disconnect(); // 一度処理が終わったら監視を停止
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

/**
 * CustomerFieldsApp オブジェクトの準備ができるまで待機します。
 */
function customerFieldsAppReady() {
    return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
            if (typeof window["CustomerFieldsApp"] !== "undefined") {
                clearInterval(checkInterval);
                resolve(window["CustomerFieldsApp"]);
            }
        }, 100);
    });
}

/**
 * 登録完了後のリダイレクト設定
 */
customerFieldsAppReady().then((cf_app) => {
    cf_app.settings.onNewCustomerSuccess = function (form, response) {
        // 登録ページに ?return_to=/pages/... が付いていれば、その相対パスへ戻す（2026-09-03・T-0207）
        // 同一オリジンに解決される値だけを許可する。文字列の先頭だけを見る判定では
        // "/\evil.com" や改行・タブを挟んだ値がブラウザのURL正規化で外部ドメインになり、
        // 登録直後に他サイトへ飛ばせてしまう（オープンリダイレクト）ため、URLとして解決してから比較する。
        const returnTo = new URLSearchParams(window.location.search).get("return_to");
        if (returnTo) {
            let target = null;
            try {
                const resolved = new URL(returnTo, window.location.origin);
                if (resolved.origin === window.location.origin) {
                    target = resolved.pathname + resolved.search + resolved.hash;
                }
            } catch (e) {
                target = null;
            }

            if (target) {
                window.location.href = target;
                return;
            }
        }

        const referrer = document.referrer;
        if (referrer && referrer.includes('/pages/pillow_exchange')) {
            window.location.href = '/pages/pillow_exchange';
        } else {
            window.location.href = '/pages/register_complete';
        }
    };
});

/*郵便番号検索*/
document.addEventListener("DOMContentLoaded", function () {
    //console.log("スクリプトが読み込まれました");

    function addSearchButton() {
        const zipInput = document.getElementById("customer-address-zip");

        if (zipInput) {
            //console.log("郵便番号入力フィールドが見つかりました:", zipInput);

            // すでにボタンがある場合は追加しない
            if (document.getElementById("searchAddress")) {
                //console.log("住所検索ボタンはすでに存在しています");
                return;
            }

            // ボタン要素を作成
            const searchButton = document.createElement("button");
            searchButton.type = "button";
            searchButton.id = "searchAddress";
            searchButton.textContent = "郵便番号検索";

            // 郵便番号入力欄の直後にボタンを追加
            zipInput.parentNode.insertBefore(searchButton, zipInput.nextSibling);
            //console.log("住所検索ボタンを追加しました:", searchButton);
        } else {
            console.warn(
                "郵便番号入力フィールドがまだ見つかりません。再試行します..."
            );
        }
    }

    // `MutationObserver` で郵便番号入力フィールドが追加されるのを監視
    const observer = new MutationObserver(() => {
        if (document.getElementById("customer-address-zip")) {
            //console.log("郵便番号入力フィールドがDOMに追加されました");
            addSearchButton();
            observer.disconnect(); // ボタンが追加されたら監視を停止
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // すでにページロード時に郵便番号入力フィールドがあれば即時実行
    if (document.getElementById("customer-address-zip")) {
        //console.log("郵便番号入力フィールドがすでに存在しているため、即時実行");
        addSearchButton();
    }
});

document.addEventListener("DOMContentLoaded", function () {
    //console.log("スクリプトが読み込まれました");

    const prefecturesMap = {
        北海道: "Hokkaidō",
        青森県: "Aomori",
        岩手県: "Iwate",
        宮城県: "Miyagi",
        秋田県: "Akita",
        山形県: "Yamagata",
        福島県: "Fukushima",
        茨城県: "Ibaraki",
        栃木県: "Tochigi",
        群馬県: "Gunma",
        埼玉県: "Saitama",
        千葉県: "Chiba",
        東京都: "Tōkyō",
        神奈川県: "Kanagawa",
        新潟県: "Niigata",
        富山県: "Toyama",
        石川県: "Ishikawa",
        福井県: "Fukui",
        山梨県: "Yamanashi",
        長野県: "Nagano",
        岐阜県: "Gifu",
        静岡県: "Shizuoka",
        愛知県: "Aichi",
        三重県: "Mie",
        滋賀県: "Shiga",
        京都府: "Kyōto",
        大阪府: "Ōsaka",
        兵庫県: "Hyōgo",
        奈良県: "Nara",
        和歌山県: "Wakayama",
        鳥取県: "Tottori",
        島根県: "Shimane",
        岡山県: "Okayama",
        広島県: "Hiroshima",
        山口県: "Yamaguchi",
        徳島県: "Tokushima",
        香川県: "Kagawa",
        愛媛県: "Ehime",
        高知県: "Kōchi",
        福岡県: "Fukuoka",
        佐賀県: "Saga",
        長崎県: "Nagasaki",
        熊本県: "Kumamoto",
        大分県: "Ōita",
        宮崎県: "Miyazaki",
        鹿児島県: "Kagoshima",
        沖縄県: "Okinawa",
    };

    function initializeScript() {
        let searchButton = document.getElementById("searchAddress");
        if (!searchButton) {
            console.warn("searchAddress ボタンがまだ見つかりません。再試行します...");
            return;
        }

        console.log("searchAddress ボタンが見つかりました");

        searchButton.addEventListener("click", function () {
            //console.log("住所検索ボタンがクリックされました");

            let zipcodeField = document.getElementById("customer-address-zip");
            if (!zipcodeField) {
                //console.error("エラー: 郵便番号入力フィールドが見つかりません");
                return;
            }

            let zipcode = zipcodeField.value.replace("-", "").trim();
            //console.log("入力された郵便番号:", zipcode);

            if (zipcode.length !== 7 || isNaN(zipcode)) {
                console.warn("郵便番号の形式が正しくありません");
                alert("正しい郵便番号を入力してください");
                return;
            }

            let apiUrl = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`;
            //console.log("APIリクエストURL:", apiUrl);

            fetch(apiUrl)
                .then((response) => response.json())
                .then((data) => {
                    console.log("APIレスポンスデータ:", data);

                    if (data.status === 200 && data.results) {
                        let addressData = data.results[0];

                        //console.log("取得した都道府県:", addressData.address1);
                        //console.log("取得した市区町村:", addressData.address2);
                        //console.log("取得した町域:", addressData.address3);

                        let provinceSelect = document.getElementById(
                            "customer-address-province"
                        );
                        if (!provinceSelect) {
                            //console.error("エラー: 都道府県セレクトボックスが見つかりません");
                            return;
                        }

                        let prefectureName = addressData.address1;
                        let prefectureValue = prefecturesMap[prefectureName];

                        if (prefectureValue) {
                            provinceSelect.value = prefectureValue;
                            //console.log("都道府県を選択しました:", prefectureValue);
                        } else {
                            console.warn(
                                "都道府県のマッピングが見つかりません:",
                                prefectureName
                            );
                        }

                        let cityField = document.getElementById("customer-address-city");
                        if (cityField) {
                            cityField.value = addressData.address2;
                            //console.log("市区町村を設定:", addressData.address2);
                        } else {
                            //console.error("エラー: 市区町村フィールドが見つかりません");
                        }

                        let addressField = document.getElementById(
                            "customer-address-address1"
                        );
                        if (addressField) {
                            addressField.value = addressData.address3;
                            //console.log("住所フィールドに設定:", addressData.address3);
                        } else {
                            //console.error("エラー: 住所フィールドが見つかりません");
                        }
                    } else {
                        //console.error("住所データが見つかりませんでした:", data.message);
                        alert("郵便番号に対応する住所が見つかりませんでした");
                    }
                })
                .catch((error) => {
                    //console.error("APIエラー発生:", error);
                    alert("住所検索中にエラーが発生しました");
                });
        });
    }

    // `MutationObserver` を使ってボタンが表示されるのを待つ
    const observer = new MutationObserver(() => {
        if (document.getElementById("searchAddress")) {
            //console.log("searchAddress ボタンがDOMに追加されました");
            initializeScript();
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // すでにページロード時にボタンがあれば即時実行
    if (document.getElementById("searchAddress")) {
        //console.log("searchAddress ボタンがすでに存在しているため、即時実行");
        initializeScript();
    }
});

// 生年月日の日付バリデーション機能
function tryGetElements() {
    // 方法1: 通常のgetElementById
    let yearSelect = document.getElementById('customer-birthday-y');
    let monthSelect = document.getElementById('customer-birthday-m');
    let daySelect = document.getElementById('customer-birthday-d');

    // 方法2: querySelectorで属性から取得
    if (!yearSelect || !monthSelect || !daySelect) {
        yearSelect = document.querySelector('select[name="customer[birthday_y]"]');
        monthSelect = document.querySelector('select[name="customer[birthday_m]"]');
        daySelect = document.querySelector('select[name="customer[birthday_d]"]');
    }

    // 方法3: data属性から取得
    if (!yearSelect || !monthSelect || !daySelect) {
        yearSelect = document.querySelector('[data-machine-name="birthday_y"]');
        monthSelect = document.querySelector('[data-machine-name="birthday_m"]');
        daySelect = document.querySelector('[data-machine-name="birthday_d"]');
    }

    // 方法4: iframe内を検索
    if (!yearSelect || !monthSelect || !daySelect) {
        const iframes = document.querySelectorAll('iframe');
        for (let iframe of iframes) {
            try {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                if (!yearSelect) yearSelect = iframeDoc.getElementById('customer-birthday-y');
                if (!monthSelect) monthSelect = iframeDoc.getElementById('customer-birthday-m');
                if (!daySelect) daySelect = iframeDoc.getElementById('customer-birthday-d');

                if (yearSelect && monthSelect && daySelect) {
                    break;
                }
            } catch (e) {
                // iframe検索エラーは無視
            }
        }
    }

    return { yearSelect, monthSelect, daySelect };
}

// メイン処理
function initValidation() {
    const { yearSelect, monthSelect, daySelect } = tryGetElements();

    if (!yearSelect || !monthSelect || !daySelect) {
        return false;
    }

    // エラーメッセージ表示用のdiv要素を作成
    let errorDiv = document.getElementById('date-error');
    if (!errorDiv) {
        errorDiv = document.createElement('div');
        errorDiv.id = 'date-error';
        errorDiv.style.cssText = 'color: red; font-size: 14px; display: none; font-weight: bold;';

        // data-wrapper-for="birthday_d"の要素を探す
        const dayWrapper = document.querySelector('[data-wrapper-for="birthday_d"]');
        if (dayWrapper && dayWrapper.parentNode) {
            // 日付選択フィールドの直後に挿入
            dayWrapper.parentNode.insertBefore(errorDiv, dayWrapper.nextSibling);
        } else if (daySelect.parentNode) {
            // フォールバック: daySelectの親要素に追加
            daySelect.parentNode.appendChild(errorDiv);
        } else {
            // 最終フォールバック: body要素に追加
            document.body.appendChild(errorDiv);
        }
    }

    // 日付検証関数
    function isValidDate(year, month, day) {
        if (!year || !month || !day) return true;

        year = parseInt(year);
        month = parseInt(month);
        day = parseInt(day);

        if (month < 1 || month > 12) return false;

        const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // うるう年判定
        if (month === 2) {
            const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
            if (isLeapYear) daysInMonth[1] = 29;
        }

        return day >= 1 && day <= daysInMonth[month - 1];
    }

    // バリデーション実行
    function validateDate() {
        const year = yearSelect.value;
        const month = monthSelect.value;
        const day = daySelect.value;

        if (year && month && day) {
            if (!isValidDate(year, month, day)) {
                errorDiv.textContent = '存在しない日付が選択されています。正しい日付を選択してください。';
                errorDiv.style.display = 'block';
            } else {
                errorDiv.textContent = '';
                errorDiv.style.display = 'none';
            }
        } else {
            errorDiv.textContent = '';
            errorDiv.style.display = 'none';
        }
    }

    // イベントリスナー追加
    yearSelect.addEventListener('change', validateDate);
    monthSelect.addEventListener('change', validateDate);
    daySelect.addEventListener('change', validateDate);

    return true;
}

// 複数のタイミングで初期化を試みる

// 1. 即座に実行
initValidation();

// 2. DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
    initValidation();
});

// 3. window.onload
window.addEventListener('load', function () {
    initValidation();
});

// 4. MutationObserverで動的に生成される要素を監視
const observer = new MutationObserver(function (mutations) {
    const { yearSelect, monthSelect, daySelect } = tryGetElements();
    if (yearSelect && monthSelect && daySelect) {
        if (initValidation()) {
            observer.disconnect(); // 監視を停止
        }
    }
});

// body全体を監視
observer.observe(document.body, {
    childList: true,
    subtree: true
});

// 5. 定期的な再試行（最大10回）
let retryCount = 0;
const retryInterval = setInterval(function () {
    retryCount++;

    if (initValidation() || retryCount >= 10) {
        clearInterval(retryInterval);
    }
}, 1000); // 1秒ごとに再試行